<template>
  <button class="action-button" @click="print">
    <svg
      version="1.1"
      id="print"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      viewBox="0 0 16 16"
      style="enable-background:new 0 0 16 16;"
      xml:space="preserve"
    >
      <g>
        <path
          style="fill:#fff;"
          d="M4,12.5v3h8v-3v-2H4V12.5z M5,11.5h6v1H5V11.5z M5,13.5h6v1H5V13.5z"
        />
        <polygon
          style="fill:#fff;"
          points="12,3.5 12,0.5 4,0.5 4,3.5 4,5.5 12,5.5 		"
        />
        <path
          style="fill:#fff;"
          d="M14,3.5h-1v2v1H3v-1v-2H2c-1,0-2,1-2,2v5c0,1,1,2,2,2h1v-2v-1h10v1v2h1c1,0,2-1,2-2v-5
          C16,4.5,15,3.5,14,3.5z"
        />
      </g>
    </svg>
  </button>
</template>

<script>
import { EventBus } from '@/eventBus';

export default {
  methods: {
    print() {
      EventBus.$emit('print');
    },
  },
};
</script>
